module.exports = __webpack_public_path__ + "static/media/bg.283b30c6.png";